import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "grid grid-cols-1 md:grid-cols-2 gap-8 items-start"
}
const _hoisted_2 = { class: "space-y-4" }
const _hoisted_3 = { class: "w-full" }

import Paragraph from "@/views/blocks/shared/section/typography/paragraph/Paragraph.vue";
import Image from "@/views/blocks/shared/section/image/Image.vue";

interface TabItem {
    id: number;
    label: string;
    title: string;
    description: string;
    imageSrc: string;
    imageAlt: string;
}

interface TabsContentProps {
    activeTabContent: TabItem | undefined;
    tabTitleTextColor: string;
    tabDescriptionTextColor: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TabsContent',
  props: {
    activeTabContent: {},
    tabTitleTextColor: {},
    tabDescriptionTextColor: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_ctx.activeTabContent)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(Paragraph, {
            text: _ctx.activeTabContent.title,
            textColor: _ctx.tabTitleTextColor,
            class: "text-lg"
          }, null, 8, ["text", "textColor"]),
          _createVNode(Paragraph, {
            text: _ctx.activeTabContent.description,
            textColor: _ctx.tabDescriptionTextColor,
            class: "opacity-70"
          }, null, 8, ["text", "textColor"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(Image, {
            src: _ctx.activeTabContent.imageSrc,
            alt: _ctx.activeTabContent.imageAlt,
            class: "w-full h-auto rounded-lg object-cover aspect-[5/2]",
            width: "624",
            height: "250"
          }, null, 8, ["src", "alt"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})